<section
  class="delivery-date-column"
  [attr.data-testid]="'delivery-date-column-' + column().deliveryDate"
>
  <header class="delivery-date-column__header" aria-hidden="true">
    <p class="delivery-date-column__arriving">
      {{ 'createShipment.serviceStep.deliveryService.arrivingOn' | translate }}
    </p>
    <p class="delivery-date-column__date">
      {{ formatArrivingOnDate(column().deliveryDate) }}
    </p>
  </header>
  <h3 class="visually-hidden">
    {{ 'createShipment.serviceStep.deliveryService.arrivingOn' | translate }}
    {{ formatArrivingOnDate(column().deliveryDate) }}
  </h3>

  <div class="delivery-date-column__cards">
    @for (offering of column().offerings; track offering.productCode) {
      <app-delivery-service-card
        [offering]="offering"
        [selected]="selectedProductCode() === offering.productCode"
        [fastest]="fastestProductCode() === offering.productCode"
        [mostEconomical]="mostEconomicalProductCode() === offering.productCode"
        (offeringSelect)="onSelect($event)"
      />
    }
  </div>
</section>
